module.exports = __webpack_public_path__ + "img/app_btn2.d9459441.png";